import React from "react";
import {useGrafikHoehe} from "./FolienHoehe.js";

const QUELLEN = [
    {y: 8, titel: "Verkäufe", zeile2: ["Altes ERP bis 06/2026,", "Weclapp seit 07/2026"]},
    {y: 82, titel: "Bestand SNV Weilheim", zeile2: "stündlich aktualisiert"},
    {y: 156, titel: "Offene Kundenaufträge", zeile2: "laufend aus Weclapp"},
    {y: 230, titel: "Cosmos-Zusagen", zeile2: "Ampel-Datei, Lieferscheine"},
    {y: 304, titel: "B2B-Shop-Nachfrage", zeile2: "Bestellungen, Suchen, Warenkörbe"},
];

const ZIELE = [
    {y: 40, titel: "Lieferfähigkeit", zeile2: "wann geht welcher Farbton aus"},
    {y: 150, titel: "Artikel-Blatt", zeile2: "Zeitstrahl je Farbton"},
    {y: 260, titel: "Bestellvorschläge", zeile2: "je Kalenderwoche und LKW"},
];

const QUELLE_X = 8;
const QUELLE_BREITE = 232;
const QUELLE_HOEHE = 60;
const KERN_X = 328;
const KERN_BREITE = 220;
const KERN_Y = 132;
const KERN_HOEHE = 96;
const ZIEL_X = 636;
const ZIEL_BREITE = 232;
const ZIEL_HOEHE = 64;

function mitte(y, hoehe) {
    return y + hoehe / 2;
}

/**
 * Eigenes SVG-Schaubild "Woher die Zahlen kommen" (Folie 1, Auftrag S7):
 * fünf Quellen fließen in den Rechenkern, aus dem drei Bildschirme entstehen.
 * Bewusst ohne externe Chart-Bibliothek - eine reine Fluss-Illustration statt
 * einer Datenkurve.
 */
export default function FlussSchaubild() {
    const grafikHoehe = useGrafikHoehe();
    return (
        <svg viewBox="0 0 900 380" role="img" aria-label="Fünf Datenquellen fließen in den Rechenkern, aus dem drei Bildschirme entstehen." style={{width: "100%", height: grafikHoehe ?? "auto", maxHeight: grafikHoehe ?? undefined, minWidth: 640, display: "block"}}>
            <defs>
                <marker id="fluss-pfeil" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
                    <path d="M0,0 L8,4 L0,8 Z" fill="#868e96" />
                </marker>
            </defs>

            {QUELLEN.map((q) => (
                <line
                    key={`linie-q-${q.titel}`}
                    x1={QUELLE_X + QUELLE_BREITE}
                    y1={mitte(q.y, QUELLE_HOEHE)}
                    x2={KERN_X}
                    y2={mitte(KERN_Y, KERN_HOEHE)}
                    stroke="#adb5bd"
                    strokeWidth={1.5}
                    markerEnd="url(#fluss-pfeil)"
                />
            ))}
            {ZIELE.map((z) => (
                <line
                    key={`linie-z-${z.titel}`}
                    x1={KERN_X + KERN_BREITE}
                    y1={mitte(KERN_Y, KERN_HOEHE)}
                    x2={ZIEL_X}
                    y2={mitte(z.y, ZIEL_HOEHE)}
                    stroke="#adb5bd"
                    strokeWidth={1.5}
                    markerEnd="url(#fluss-pfeil)"
                />
            ))}

            {QUELLEN.map((q) => {
                const zeilen = Array.isArray(q.zeile2) ? q.zeile2 : [q.zeile2];
                const ersteZeileY = zeilen.length > 1 ? q.y + 38 : q.y + 44;
                return (
                    <g key={q.titel}>
                        <rect x={QUELLE_X} y={q.y} width={QUELLE_BREITE} height={QUELLE_HOEHE} rx={8} fill="#f8f9fa" stroke="#ced4da" />
                        <text x={QUELLE_X + 12} y={q.y + 24} fontSize={14} fontWeight={600} fill="#212529">
                            {q.titel}
                        </text>
                        {zeilen.map((zeile, i) => (
                            <text key={i} x={QUELLE_X + 12} y={ersteZeileY + i * 12} fontSize={11} fill="#6c757d">
                                {zeile}
                            </text>
                        ))}
                    </g>
                );
            })}

            <rect x={KERN_X} y={KERN_Y} width={KERN_BREITE} height={KERN_HOEHE} rx={10} fill="#eef7cc" stroke="#a3d900" strokeWidth={2} />
            <text x={KERN_X + KERN_BREITE / 2} y={KERN_Y + 36} fontSize={16} fontWeight={700} fill="#3a4a00" textAnchor="middle">
                Rechenkern
            </text>
            <text x={KERN_X + KERN_BREITE / 2} y={KERN_Y + 58} fontSize={11} fill="#516000" textAnchor="middle">
                bereinigter Bedarf,
            </text>
            <text x={KERN_X + KERN_BREITE / 2} y={KERN_Y + 74} fontSize={11} fill="#516000" textAnchor="middle">
                Prognose, Bestellvorschlag
            </text>

            {ZIELE.map((z) => (
                <g key={z.titel}>
                    <rect x={ZIEL_X} y={z.y} width={ZIEL_BREITE} height={ZIEL_HOEHE} rx={8} fill="#f8f9fa" stroke="#ced4da" />
                    <text x={ZIEL_X + 12} y={z.y + 26} fontSize={14} fontWeight={600} fill="#212529">
                        {z.titel}
                    </text>
                    <text x={ZIEL_X + 12} y={z.y + 46} fontSize={11} fill="#6c757d">
                        {z.zeile2}
                    </text>
                </g>
            ))}
        </svg>
    );
}
